import { Trash01 } from "@untitled-ui/icons-react";
import { useTranslation } from "react-i18next";

import Modal from "@/components/containers/Modal";
import Button from "@/components/forms/Button";
import FeatureIcon from "@/components/helpers/FeatureIcon";

type GroupLeaveModalProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
  isDelete?: boolean;
};

export default function GroupLeaveModal({
  open,
  onClose,
  onConfirm,
  isLoading,
  isDelete = true,
}: GroupLeaveModalProps) {
  const { t } = useTranslation("messenger.user");

  const title = isDelete ? t("Delete and leave group") : t("Leave group");
  const description = isDelete
    ? t("Are you sure you want to delete and leave this group?")
    : t("Are you sure you want to leave this group?");

  return (
    <Modal
      open={open}
      onClose={onClose}
      size="sm"
      footer={
        <div className="grid grid-cols-1 gap-3 border-t p-6">
          <Button
            color="primary"
            variant="error"
            className="w-full"
            onClick={onConfirm}
            isLoading={isLoading}
          >
            {title}
          </Button>
          <Button color="secondary-gray" className="w-full" onClick={onClose}>
            {t("Cancel", { ns: "core.shared" })}
          </Button>
        </div>
      }
    >
      <div className="flex flex-col gap-4">
        <FeatureIcon variant="modern" color="error" className="self-start">
          <Trash01 className="text-error-600 size-5" />
        </FeatureIcon>
        <div className="flex flex-col gap-2">
          <span className="text-lg font-semibold text-gray-900">{title}</span>
          <span className="text-sm text-gray-600">{description}</span>
        </div>
      </div>
    </Modal>
  );
}
